/**
 * AccordionController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Navigation.AccordionController = function () {
  var accordionTitleSelector = '.r-tabs-accordion-title';
  var accordionIconClasses = 'icon icon-arrow-left';
  var $accordion = $('.js-accordion');

  $accordion.responsiveTabs({
    setHash: true,
    animationQueue: false,
    accordionMultiCollapse: false
  });

  $accordion.find(accordionTitleSelector).addClass(accordionIconClasses);
};